// NGRX
import { Action } from "@ngrx/store";
import { Update } from "@ngrx/entity";
// CRUD
import { User } from "..";
// Models
import { QueryParamsModel } from "../../_base/crud";

export enum UserActionTypes {
    AllUsersRequested = "[Users Module] All Users Requested",
    AllUsersLoaded = "[Users API] All Users Loaded",
    CreateUser = "[Edit User Component]  Create User",
    CreateUserSuccess = "[Edit User Dialog] Create User Success",
    CreateUserFail = "[Edit User Dialog] Create User Fail",
    UserUpdated = "[Edit User Dialog] User Updated",
    BlockUser = "[Users List Page] Block User",
    BlockUserSuccess = "[Users List Page] Block User Success",
    ActivateUser = "[Users List Page] Activate User",
    ActivateUserSuccess = "[Users List Page] Activate User Success",
    UsersPageRequested = "[Users List Page] Users Page Requested",
    CRMUsersPageRequested = "[Users List Page] CRM Users Page Requested",
    UsersPageLoaded = "[Users API] Users Page Loaded",
    UsersPageCancelled = "[Users API] Users Page Cancelled",
    UsersPageToggleLoading = "[Users] Users Page Toggle Loading",
    UsersActionToggleLoading = "[Users] Users Action Toggle Loading",
    CANCEL_SEARCH_REQUEST = "[Users] Cancel Search Request"
}

export class CreateUser implements Action {
    readonly type = UserActionTypes.CreateUser;

    constructor(public payload: { user: User }) {}
}

export class CreateUserSuccess implements Action {
    readonly type = UserActionTypes.CreateUserSuccess;

    constructor(public payload: { user: User }) {}
}

export class CreateUserFail implements Action {
    readonly type = UserActionTypes.CreateUserFail;

    constructor(public payload: string[]) {}
}

export class UserUpdated implements Action {
    readonly type = UserActionTypes.UserUpdated;

    constructor(
        public payload: {
            partialUser: Update<User>;
            user: User;
        }
    ) {}
}

export class BlockUser implements Action {
    readonly type = UserActionTypes.BlockUser;

    constructor(public payload: { user: User }) {}
}

export class BlockUserSuccess implements Action {
    readonly type = UserActionTypes.BlockUserSuccess;

    constructor(public payload: { userUpdated: Update<User> }) {}
}

export class ActivateUser implements Action {
    readonly type = UserActionTypes.ActivateUser;

    constructor(public payload: { user: User }) {}
}

export class ActivateUserSuccess implements Action {
    readonly type = UserActionTypes.ActivateUserSuccess;

    constructor(public payload: { userUpdated: Update<User> }) {}
}

export class UsersPageRequested implements Action {
    readonly type = UserActionTypes.UsersPageRequested;

    constructor(public payload: { page: QueryParamsModel }) {}
}

export class CancelSearchRequest implements Action {
    readonly type = UserActionTypes.CANCEL_SEARCH_REQUEST;
}

export class CRMUsersPageRequested implements Action {
    readonly type = UserActionTypes.CRMUsersPageRequested;

    constructor(public payload: { page: QueryParamsModel }) {}
}

export class UsersPageLoaded implements Action {
    readonly type = UserActionTypes.UsersPageLoaded;

    constructor(
        public payload: {
            users: any[];
            totalCount: number;
            page: QueryParamsModel;
        }
    ) {}
}

export class UsersPageCancelled implements Action {
    readonly type = UserActionTypes.UsersPageCancelled;
}

export class UsersPageToggleLoading implements Action {
    readonly type = UserActionTypes.UsersPageToggleLoading;

    constructor(public payload: { isLoading: boolean }) {}
}

export class UsersActionToggleLoading implements Action {
    readonly type = UserActionTypes.UsersActionToggleLoading;

    constructor(public payload: { isLoading: boolean }) {}
}

export type UserActions =
    | UserUpdated
    | BlockUser
    | BlockUserSuccess
    | ActivateUser
    | ActivateUserSuccess
    | CreateUser
    | CreateUserSuccess
    | CreateUserFail
    | UsersPageLoaded
    | UsersPageCancelled
    | UsersPageToggleLoading
    | UsersPageRequested
    | CRMUsersPageRequested
    | UsersActionToggleLoading
    | CancelSearchRequest;
